<div class="reply-to-line">
  <ng-container *ngFor="let fragment of fragments">
    <ng-container [ngSwitch]="fragment.type">
      <span *ngSwitchCase="LineFragmentType.TEXT">
        {{ fragment.value }}
      </span>

      <span *ngSwitchCase="LineFragmentType.IN">
        <span *ngIf="replyInOptions.length === 1">{{ selectedReplyInOption.label }}</span>
        <a *ngIf="replyInOptions.length > 1" (click)="showReplyInList($event)" href>{{
          selectedReplyInOption.label
        }}</a>
      </span>

      <ng-container *ngSwitchCase="LineFragmentType.AS">
        <span *ngIf="replyAsOptions.length === 1">{{ selectedReplyAsOption.label }}</span>
        <a *ngIf="replyAsOptions.length > 1" (click)="showReplyAsList($event)" href>{{
          selectedReplyAsOption.label
        }}</a>
      </ng-container>

      <span *ngSwitchCase="LineFragmentType.TO">
        {{ replyToName }}
      </span>

      <ng-container *ngSwitchCase="LineFragmentType.CHANGE_TO">
        <a *ngIf="replyToNOtherNamesLabel" (click)="showReplyToList($event)" href>{{ replyToNOtherNamesLabel }}</a>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<div *ngIf="canUseAIAssistant" [style.margin-right.px]="aiAssistantButtonMarginLeft" class="ai-assistant">
  <button [matTooltip]="aiTooltip" (click)="askForAIAssistant()" [disabled]="aiProcessing">
    <img
      *ngIf="aiProcessing; else waitingForProcessingIcon"
      [src]="'assets/img/ai-loading.gif'"
      alt="AI Assistant is processing an answer" />

    <ng-template #waitingForProcessingIcon>
      <ion-icon
        *ngIf="basicService.answerSuggestionPending[taskProcessContext.processedTaskId]?.minimized; else defaultIcon"
        name="chevron-up"></ion-icon>

      <ng-template #defaultIcon>
        <!-- room_service is a mat icon, but mat icons are not availaible in widget... -->
        <ion-icon slot="icon-only" src="assets/img/room_service.svg"></ion-icon>
      </ng-template>
    </ng-template>

    <div translate="m/task-process/ai-assistant/button/label"></div>
  </button>
</div>
